import React from 'react';
import _get from 'lodash/get';
import { Link } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import { Breadcrumbs, Button, Typography, makeStyles } from '@material-ui/core';
import { getIntroductionPathname } from '../utils';

const useStyles = makeStyles(theme => ({
  breadcrumbs: {
    marginBottom: props => (props.small ? theme.spacing(2) : theme.spacing(3)),
    color: '#C0BFBF',
    fontSize: '1rem',

    '& p': {
      ...theme.typography.overline,
    },

    '& .MuiButton-root': {
      padding: props => props.small && 0,
    },
    '& .MuiBreadcrumbs-separator': {
      margin: '0px 5px',
    },
  },
  homeLink: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: theme.spacing(0.5),
    },
  },
}));

export const CourseBreadcrumbs = ({
  item,
  match,
  activeModule,
  isEnrolled,
  small,
  coursesSiteCopy,
}) => {
  const classes = useStyles({ small });
  const activeModuleTitle = _get(activeModule, 'fields.title');
  const pathname = match && getIntroductionPathname(match, isEnrolled);

  return (
    <Breadcrumbs
      className={classes.breadcrumbs}
      separator={<Typography>/</Typography>}
    >
      {pathname ? (
        <Button variant="text" color="primary">
          <Link to={pathname} className={classes.homeLink}>
            <HomeIcon fontSize="small" />
            <Typography>
              {_get(coursesSiteCopy, 'pageCopy.homeLabel')}
            </Typography>
          </Link>
        </Button>
      ) : (
        <Typography color="textPrimary">{item.fields.title}</Typography>
      )}
      {activeModuleTitle && (
        <Typography color="textPrimary">{activeModuleTitle}</Typography>
      )}
    </Breadcrumbs>
  );
};
